// @flow
import React, { PureComponent } from 'react';
import MenuElement from 'components/header/MenuElement';
import DropdownMenuElementPlus from 'components/billboard/DropdownMenuElementPlus';
import type { CategoryType } from 'types/Article';
import { Link } from 'react-router-dom';

export type StateProps = {
  categories: CategoryType[]
};

export type DispatchProps = {
  fetchCategories: () => void
};

type Props = StateProps & DispatchProps;

type State = {
  menuItems: Array<{ id: number, size: number }>,
  isMobile: boolean,
  hiddenMenuItems: number[],
  menuElements: MenuElement[],
  menuLinkX: number
};

class BillboardMenuLinks extends PureComponent<Props, State> {
  _menuElements: Array<?MenuElement>;
  _menu: ?HTMLElement;
  _menuLink: ?HTMLElement;
  _frameId: string;
  state: State = {
    menuItems: [],
    isMobile: false,
    hiddenMenuItems: [],
    menuElements: [],
    menuLinkX: 0
  };

  constructor(props: Props) {
    super(props);
    this._menuElements = [];
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions.bind(this));
    this.props.fetchCategories();
  }

  componentDidUpdate() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }

  resetMenuElementRef = (c: ?MenuElement) => {
    this._menuElements = [];
    this.addMenuElementRef(c);
  };

  addMenuElementRef = (c: ?MenuElement) => {
    this._menuElements.push(c);
  };

  isDisplayed = (id: number) => {
    return !this.state.hiddenMenuItems.includes(id);
  };

  updateDimensions() {
    const menu = this._menu;
    const menuLink = this._menuLink;
    if (menu && menuLink) {
      const menuLinkBounds = menuLink.getBoundingClientRect();
      const menuLinkX = menuLinkBounds.left;

      if (menuLinkX !== this.state.menuLinkX) this.setState({ menuLinkX });
      const maxWidth = menu.offsetWidth;
      const width_logo = 200;

      const width_menu_links = this._menuElements.reduce(
        (total, item) => (item ? total + item.getSize() * 1.1 : total),
        0
      );
      const totalWidth = width_menu_links + width_logo;

      let currentWidth = totalWidth + 200;
      let deleted = [];
      if (maxWidth > 750) {
        for (let i = this._menuElements.length - 1; i > 0; i--) {
          if (currentWidth > maxWidth) {
            if (this._menuElements[i]) currentWidth -= this._menuElements[i].getSize();
            deleted = [...deleted, i];
          }
        }
        if (this.state.isMobile) this.setState({ isMobile: false });
      } else {
        if (!this.state.isMobile) this.setState({ isMobile: true });
      }
      if (
        (deleted.length !== this.state.hiddenMenuItems.length &&
          (deleted.length > 0 || this.state.hiddenMenuItems.length > 0) &&
          !deleted.every(id => this.state.hiddenMenuItems.includes(id))) ||
        !this.state.hiddenMenuItems.every(id => deleted.includes(id))
      ) {
        this.setState({ hiddenMenuItems: deleted });
      }
    }
  }

  renderMenuElements = () => {
    return this.props.categories.map<any>((category, index) => (
      <MenuElement
        key={category.slug}
        url={`/actualites/${category.slug}`}
        title={category.name}
        isMobile={true}
        ref={index === 0 ? this.resetMenuElementRef : this.addMenuElementRef}
        id={index}
        isDisplayed={this.isDisplayed}
        menuX={this.state.menuLinkX}
      />
    ));
  };

  render() {
    const hiddenMenuElements = this.state.hiddenMenuItems.map<any>(id => {
      return this._menuElements[id];
    });
    return (
      <div className="billboard__category clearfix" ref={c => (this._menu = c)}>
        <ul className="billboard__links ft-500" ref={c => (this._menuLink = c)}>
          <li>
            <span>Par thématiques :</span>
          </li>
          {this.renderMenuElements()}
          <DropdownMenuElementPlus
            hiddenMenuElements={hiddenMenuElements}
            isMobile={false}
            id={6}
            isDisplayed={this.isDisplayed}
            menuX={this.state.menuLinkX}
          />
        </ul>
        <Link to="/actualites" className="btn btn--primary">
          <i className="icon icon-documents is-inline" />
          <span>Voir les actualités</span>
        </Link>
      </div>
    );
  }
}

export default BillboardMenuLinks;
